export const INITIALIZE_TRANSLATIONS = 'initialize-translations';
const initializeTranslations = () => ({ type: INITIALIZE_TRANSLATIONS });
export default initializeTranslations;
